module.exports = {"corporation":"Corporation","trust":"Trust","partnership":"Partnership","limited_partnership":"Limited Partnership","llc":"LLC","sole_member_llc":"Sole Member LLC"}


//////////////////
// WEBPACK FOOTER
// ./src/components/entities/resources/entityTypes.json
// module id = km+g
// module chunks = 1